
    import {
      getAllRoles,
      createRole,
      createAllRoles,
      updateRole,
      deleteRole
    } from "@/services/role";

    const state = {
      roles: [],
      processed: false
    };

    const getters = {
      getRoles(state) {
        return state.roles;
      },
      roleProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchRoles({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllRoles(
              params
            )
              .then(response => {
                commit("SET_ROLES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createRole({ commit }, role) {
          return new Promise((resolve, reject) => {
            createRole(role)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllRoles({ commit }, roles) {
          return new Promise((resolve, reject) => {
            createAllRoles(roles)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateRole({ commit }, role) {
          return new Promise((resolve, reject) => {
            updateRole(role)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteRole({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteRole(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_ROLES(state, data) {
        state.roles = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    